const HydrationActions = {
    SET_HYDRATION_COMPLETE: 'SET_HYDRATION_COMPLETE',

    setHydrationComplete: () => ({
        type: HydrationActions.SET_HYDRATION_COMPLETE,
        persist: false, // explicitly set this to false we never want to store it.
        hydrationComplete: true
    })
};

export default HydrationActions;
